import { useResponsiveMobile } from "../hooks/useResponsiveMobile";

interface BannerProps {
  pcImage: string;
  mobileImage: string;
  children: React.ReactNode;
  priority?: boolean; // 첫 화면이면 true
  className?: string;
}

const Banner = ({
  pcImage,
  mobileImage,
  children,
  priority = false,
  className = "",
}: BannerProps) => {
  const isMobile = useResponsiveMobile();

  return (
    <div
      className={`
        relative
        w-full md:max-w-[1600px]
        rounded-[24px]
        aspect-[16/5] md:aspect-[16/3.6]
        min-h-[170px] max-h-[360px]
        flex justify-center items-center
        overflow-hidden
        ${className}
      `}
    >
      {/* Background Image */}
      <img
        src={isMobile ? mobileImage : pcImage}
        alt=""
        aria-hidden="true"
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : "auto"}
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Content */}
      <div className="relative z-10 text-center">{children}</div>
    </div>
  );
};

export default Banner;
